import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

function CallLogs() {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Call Logs</Typography>
      <Paper sx={{ p: 3 }}>
        <Typography color="textSecondary">
          Call history and recordings will appear here.
        </Typography>
      </Paper>
    </Box>
  );
}

export default CallLogs;
